import { Box, Button, Center, Divider, Input, ModalBody, ModalCloseButton, ModalFooter, ModalHeader, Spinner, Text } from "@chakra-ui/react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

const MembersMailModal = ({ loading, sendMailApi, mailFormRef }: any) => {
    return (
        <Box>
            <ModalHeader textAlign="center">Send Mail </ModalHeader>
            <Divider mb={2} />
            <ModalCloseButton />
            <ModalBody>
                <Box mb={6} p={5} borderWidth="1px" borderColor="gray.200" borderRadius="xl" bg="white" boxShadow="0 2px 8px rgba(0, 0, 0, 0.08)">
                    <Box mb={4}>
                        <Text className='font-poppins text_md text_medium' mb={2}>Subject <Text as="span" color="red.500" ml={1}>*</Text></Text>
                        <Input
                            placeholder="Meeting invitation"
                            onChange={(e) => {
                                mailFormRef.current.subject = e.target.value;
                            }}
                        />
                    </Box>

                    <Box mb={4}>
                        <Text className='font-poppins text_md text_medium' mb={2}>Mail Body <Text as="span" color="red.500" ml={1}>*</Text></Text>
                        <SunEditor
                            height="250px"
                            onChange={(content) => {
                                mailFormRef.current.message = content;
                            }}
                        />
                    </Box>
                    {loading && (
                        <Center position="absolute" top={0} left={0} right={0} bottom={0} bg="rgba(255,255,255,0.6)" zIndex={10}>
                            <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="green.500" size="xl" />
                        </Center>
                    )}
                </Box>

            </ModalBody>
            <ModalFooter>
                <Button colorScheme="green" mt={4} onClick={sendMailApi} isLoading={loading} loadingText="Sending..." spinnerPlacement="start" isDisabled={loading} >
                    Send Mail
                </Button>
            </ModalFooter>
        </Box>

    )
}

export default MembersMailModal;